import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { Response } from 'services/api/types'

type Params = {
  proposalId: string
}

export type HandSignedProposal = {
  id: number
  companyId: string
  trackingType: string
  subject: string
  text: string
  dateHeld: string
  datePlanned: string
  attachments: string[]
}

const loadHandSignedProposals = (
  params: Params
): Response<HandSignedProposal[]> => {
  return axios.get(`/orders/proposals/${params.proposalId}/signatures`, {
    params: {
      page: 1,
      limit: 100
    }
  })
}

export function useLoadHandSignedProposals(params: Params) {
  return useQuery(
    ['loadHandSignedProposals', params],
    () => loadHandSignedProposals(params),
    {
      enabled: !!params?.proposalId,
      keepPreviousData: true,
      onError: () =>
        toast.error(
          'Não foi possível carregar os documentos assinados manualmente',
          {
            toastId: 'loadHandSignedProposals'
          }
        )
    }
  )
}
